/* KUSTM Designer — front + back sides, drag/resize, per-side surcharge, two-line cart add */
(function () {
  'use strict';
  const stage = document.querySelector('[data-kustm-stage]');
  if (!stage) return;
  const canvas = stage.querySelector('[data-kustm-canvas]');
  const mockupImg = stage.querySelector('[data-kustm-mockup]');
  const printZone = stage.querySelector('[data-kustm-print-zone]');
  const fileInput = stage.querySelector('[data-kustm-file]');
  const uploadBtn = stage.querySelector('[data-kustm-action="upload"]');
  const uploadLabel = stage.querySelector('[data-kustm-upload-label]');
  const resetBtn = stage.querySelector('[data-kustm-action="reset"]');
  const sideTabs = stage.querySelectorAll('[data-kustm-side-tab]');
  const form = document.querySelector('[data-kustm-form]');
  const variantInput = form.querySelector('[data-kustm-variant-id]');
  const propFrontImage = form.querySelector('[data-kustm-prop-front-image]');
  const propFrontPos   = form.querySelector('[data-kustm-prop-front-position]');
  const propBackImage  = form.querySelector('[data-kustm-prop-back-image]');
  const propBackPos    = form.querySelector('[data-kustm-prop-back-position]');
  const propSummary    = form.querySelector('[data-kustm-prop-summary]');
  const priceEls = document.querySelectorAll('[data-kustm-price], [data-kustm-price-2]');
  const totalEl  = document.querySelector('[data-kustm-total]');
  const readoutSizeFront = document.querySelector('[data-kustm-print-size-front]');
  const readoutFeeFront  = document.querySelector('[data-kustm-print-fee-front]');
  const readoutSizeBack  = document.querySelector('[data-kustm-print-size-back]');
  const readoutFeeBack   = document.querySelector('[data-kustm-print-fee-back]');
  const productEl = document.querySelector('[data-kustm-product]');
  const configEl  = document.querySelector('[data-kustm-config]');
  const product = productEl ? JSON.parse(productEl.textContent) : null;
  const config = configEl ? JSON.parse(configEl.textContent) : {
    surcharge_variant_id: '45826095775930',
    rate_per_sq_in: 0.06,
    min_surcharge_front: 3,
    min_surcharge_back: 5,
    product_type: '',
    product_handle: '',
    mockups: {},
  };

  // % of canvas occupied by the printable zone for each garment
  const PRINT_ZONES = {
    front: {
      'tshirt':     { top: 22, left: 32, width: 36, height: 38 },
      'longsleeve': { top: 22, left: 33, width: 34, height: 38 },
      'hoodie':     { top: 30, left: 32, width: 36, height: 30 },
      'joggers':    { top: 35, left: 18, width: 24, height: 30 },
      'youth_tshirt':     { top: 24, left: 34, width: 32, height: 34 },
      'youth_longsleeve': { top: 24, left: 35, width: 30, height: 34 },
      'youth_hoodie':     { top: 32, left: 34, width: 32, height: 26 },
      'infant_tshirt':     { top: 28, left: 38, width: 24, height: 26 },
      'infant_longsleeve': { top: 28, left: 39, width: 22, height: 26 },
      'infant_hoodie':     { top: 36, left: 38, width: 24, height: 20 },
      'oversized_tshirt':  { top: 20, left: 28, width: 44, height: 42 },
      'oversized_hoodie':  { top: 28, left: 28, width: 44, height: 32 },
    },
    back: {
      'tshirt':     { top: 22, left: 30, width: 40, height: 42 },
      'longsleeve': { top: 22, left: 31, width: 38, height: 42 },
      'hoodie':     { top: 28, left: 30, width: 40, height: 40 },
      'joggers':    { top: 35, left: 50, width: 14, height: 18 }, // single-leg back placement
      'youth_tshirt':     { top: 24, left: 32, width: 36, height: 38 },
      'youth_longsleeve': { top: 24, left: 33, width: 34, height: 38 },
      'youth_hoodie':     { top: 30, left: 32, width: 36, height: 36 },
      'infant_tshirt':     { top: 28, left: 36, width: 28, height: 28 },
      'infant_longsleeve': { top: 28, left: 37, width: 26, height: 28 },
      'infant_hoodie':     { top: 34, left: 36, width: 28, height: 24 },
      'oversized_tshirt':  { top: 20, left: 26, width: 48, height: 46 },
      'oversized_hoodie':  { top: 26, left: 28, width: 44, height: 42 },
    },
  };

  // Real-world inch dimensions of the printable zone for each garment (per side)
  const PRINT_ZONES_INCHES = {
    front: {
      'tshirt':     { width_in: 12, height_in: 14 },
      'longsleeve': { width_in: 12, height_in: 14 },
      'hoodie':     { width_in: 12, height_in: 11 },
      'joggers':    { width_in: 6,  height_in: 8 },
      'youth_tshirt':     { width_in: 9, height_in: 10 },
      'youth_longsleeve': { width_in: 9, height_in: 10 },
      'youth_hoodie':     { width_in: 9, height_in: 8 },
      'infant_tshirt':     { width_in: 6, height_in: 6 },
      'infant_longsleeve': { width_in: 6, height_in: 6 },
      'infant_hoodie':     { width_in: 6, height_in: 5 },
      'oversized_tshirt':  { width_in: 14, height_in: 16 },
      'oversized_hoodie':  { width_in: 13, height_in: 12 },
    },
    back: {
      'tshirt':     { width_in: 14, height_in: 16 }, // larger back print area
      'longsleeve': { width_in: 14, height_in: 16 },
      'hoodie':     { width_in: 14, height_in: 14 },
      'joggers':    { width_in: 4,  height_in: 5 },
      'youth_tshirt':     { width_in: 11, height_in: 12 },
      'youth_longsleeve': { width_in: 11, height_in: 12 },
      'youth_hoodie':     { width_in: 11, height_in: 11 },
      'infant_tshirt':     { width_in: 7, height_in: 7 },
      'infant_longsleeve': { width_in: 7, height_in: 7 },
      'infant_hoodie':     { width_in: 7, height_in: 6 },
      'oversized_tshirt':  { width_in: 16, height_in: 18 },
      'oversized_hoodie':  { width_in: 15, height_in: 15 },
    },
  };

  function detectKey() {
    const hay = ((config.product_type || '') + ' ' + (config.product_handle || '') + ' ' + (product?.type || '') + ' ' + (product?.title || '')).toLowerCase();
    const isYouth = /\byouth\b|\bkid|\bkids\b/.test(hay);
    const isInfant = /\binfant|\bbaby\b/.test(hay);
    const isOversized = /\boversized\b|\bover-sized\b|\bover sized\b/.test(hay);
    let base;
    if (hay.includes('long')) base = 'longsleeve';
    else if (hay.includes('hood')) base = 'hoodie';
    else if (hay.includes('jog')) base = 'joggers';
    else base = 'tshirt';
    if (isInfant && base !== 'joggers') return 'infant_' + base;
    if (isYouth && base !== 'joggers') return 'youth_' + base;
    if (isOversized && (base === 'tshirt' || base === 'hoodie')) return 'oversized_' + base;
    return base;
  }
  const productKey = detectKey();

  function zoneFor(side) { return PRINT_ZONES[side][productKey] || PRINT_ZONES.front.tshirt; }
  function zoneInchesFor(side) { return PRINT_ZONES_INCHES[side][productKey] || PRINT_ZONES_INCHES.front.tshirt; }
  function minSurchargeFor(side) {
    return side === 'back' ? (config.min_surcharge_back ?? 5) : (config.min_surcharge_front ?? 3);
  }

  // --- Color slug helper ---
  // Map Shopify option values like "Heather Grey" -> "heathergrey" to match the mockup map keys.
  function colorSlug(name) {
    if (!name) return 'white';
    return String(name).toLowerCase().replace(/[^a-z0-9]/g, '');
  }

  function getCurrentColor() {
    const opts = getSelectedOptions();
    return colorSlug(opts['Color'] || opts['color'] || 'white');
  }

  function mockupFor(side, colorKey) {
    const m = (config.mockups && config.mockups[productKey]) || {};
    const c = m[colorKey] || {};
    if (c[side]) return c[side];
    // Fallback: white front uses Liquid-rendered featured_image (mockupImg.src on init);
    // white back has its own URL in the map.
    if (side === 'front') return INITIAL_FRONT_SRC;
    if (side === 'back' && (m.white || {}).back) return m.white.back;
    return INITIAL_FRONT_SRC;
  }

  const INITIAL_FRONT_SRC = mockupImg.src;

  // --- Per-side state ---
  const sides = {
    front: { artEl: null, x:0, y:0, w:0, h:0, src:'', mockupSrc: INITIAL_FRONT_SRC },
    back:  { artEl: null, x:0, y:0, w:0, h:0, src:'', mockupSrc: mockupFor('back', 'white') },
  };
  let currentSide = 'front';

  function applyZone() {
    const z = zoneFor(currentSide);
    printZone.style.top = z.top + '%';
    printZone.style.left = z.left + '%';
    printZone.style.width = z.width + '%';
    printZone.style.height = z.height + '%';
  }

  function showSide(side) {
    if (side === currentSide) return;
    // hide current side's art
    const prev = sides[currentSide];
    if (prev.artEl) prev.artEl.style.display = 'none';

    currentSide = side;

    // swap mockup image with quick fade
    canvas.classList.add('is-swapping');
    setTimeout(() => {
      mockupImg.src = sides[side].mockupSrc;
      applyZone();
      const cur = sides[side];
      if (cur.artEl) {
        cur.artEl.style.display = '';
        // re-clamp in case canvas resized
        cur.artEl.style.left = cur.x + 'px';
        cur.artEl.style.top  = cur.y + 'px';
        cur.artEl.style.width = cur.w + 'px';
        cur.artEl.style.height = cur.h + 'px';
      }
      canvas.classList.remove('is-swapping');
    }, 120);

    // update tab UI
    sideTabs.forEach(t => {
      const isActive = t.dataset.kustmSideTab === side;
      t.classList.toggle('is-active', isActive);
      t.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    // update buttons
    if (uploadLabel) uploadLabel.textContent = sides[side].src ? `Replace ${side} art` : `Upload ${side} art`;
    resetBtn.hidden = !sides[side].src;
  }

  sideTabs.forEach(t => t.addEventListener('click', () => showSide(t.dataset.kustmSideTab)));

  applyZone();

  // --- Currency helpers ---
  const moneyFormat = (window.Shopify && window.Shopify.money_format) || '${{amount}}';
  function formatMoney(cents) {
    try {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, moneyFormat);
      }
    } catch (_) {}
    return '$' + (cents / 100).toFixed(2);
  }

  // --- Upload + place art ---
  uploadBtn.addEventListener('click', () => fileInput.click());

  fileInput.addEventListener('change', (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (ev) => placeArt(ev.target.result, file);
    reader.readAsDataURL(file);
    fileInput.value = '';
  });

  function setActiveArt(targetEl) {
    canvas.querySelectorAll('.kustm-designer-art').forEach(a => {
      a.classList.toggle('is-active', a === targetEl);
    });
  }

  function deselectArt() {
    canvas.querySelectorAll('.kustm-designer-art').forEach(a => a.classList.remove('is-active'));
  }

  // Click on empty canvas area = deselect
  canvas.addEventListener('pointerdown', (e) => {
    if (e.target.closest('.kustm-designer-art')) return;
    deselectArt();
  });

  function placeArt(src, file) {
    const sideState = sides[currentSide];
    if (sideState.artEl) sideState.artEl.remove();
    const z = zoneFor(currentSide);
    const cw = canvas.clientWidth;
    const ch = canvas.clientHeight;
    const w = (z.width * 0.6 * cw) / 100;
    const h = (z.height * 0.6 * ch) / 100;
    const x = ((z.left + z.width / 2) * cw) / 100 - w / 2;
    const y = ((z.top + z.height / 2) * ch) / 100 - h / 2;

    const el = document.createElement('div');
    el.className = 'kustm-designer-art is-active';
    el.dataset.side = currentSide;
    el.style.left = x + 'px';
    el.style.top  = y + 'px';
    el.style.width  = w + 'px';
    el.style.height = h + 'px';
    const img = document.createElement('img');
    img.src = src;
    img.draggable = false;
    el.appendChild(img);
    const handle = document.createElement('div');
    handle.className = 'kustm-designer-handle';
    el.appendChild(handle);
    canvas.appendChild(el);

    sides[currentSide] = { ...sideState, artEl: el, x, y, w, h, src, file: file || sideState.file || null };
    bindInteractions(el, handle, currentSide);

    // tab indicator dot
    const tab = stage.querySelector(`[data-kustm-side-tab="${currentSide}"]`);
    if (tab) tab.dataset.hasArt = '1';

    if (uploadLabel) uploadLabel.textContent = `Replace ${currentSide} art`;
    resetBtn.hidden = false;
    syncProps();
    updateReadout();
  }

  resetBtn.addEventListener('click', () => {
    const s = sides[currentSide];
    if (s.artEl) s.artEl.remove();
    sides[currentSide] = { ...s, artEl: null, x:0, y:0, w:0, h:0, src:'' };
    const tab = stage.querySelector(`[data-kustm-side-tab="${currentSide}"]`);
    if (tab) delete tab.dataset.hasArt;
    if (uploadLabel) uploadLabel.textContent = `Upload ${currentSide} art`;
    resetBtn.hidden = true;
    syncProps();
    updateReadout();
  });

  function bindInteractions(el, handle, side) {
    let mode = null;
    let startX, startY, origLeft, origTop, origW, origH;

    function onDown(e, m) {
      mode = m;
      startX = e.clientX; startY = e.clientY;
      origLeft = parseFloat(el.style.left);
      origTop  = parseFloat(el.style.top);
      origW = parseFloat(el.style.width);
      origH = parseFloat(el.style.height);
      e.target.setPointerCapture(e.pointerId);
      e.stopPropagation();
      e.preventDefault();
    }

    el.addEventListener('pointerdown', (e) => {
      setActiveArt(el);
      if (e.target === handle) return;
      onDown(e, 'drag');
    });
    handle.addEventListener('pointerdown', (e) => { setActiveArt(el); onDown(e, 'resize'); });

    function onMove(e) {
      if (!mode) return;
      const cw = canvas.clientWidth;
      const ch = canvas.clientHeight;
      const dx = e.clientX - startX;
      const dy = e.clientY - startY;
      const s = sides[side];
      if (mode === 'drag') {
        let nx = origLeft + dx;
        let ny = origTop + dy;
        nx = Math.max(0, Math.min(cw - s.w, nx));
        ny = Math.max(0, Math.min(ch - s.h, ny));
        el.style.left = nx + 'px';
        el.style.top  = ny + 'px';
        s.x = nx; s.y = ny;
      } else if (mode === 'resize') {
        const aspect = origW / origH;
        let nw = Math.max(20, origW + dx);
        let nh = nw / aspect;
        if (origLeft + nw > cw) { nw = cw - origLeft; nh = nw / aspect; }
        if (origTop + nh > ch)  { nh = ch - origTop;  nw = nh * aspect; }
        el.style.width = nw + 'px';
        el.style.height = nh + 'px';
        s.w = nw; s.h = nh;
        updateReadout();
      }
    }

    function onUp(e) {
      if (!mode) return;
      mode = null;
      try { e.target.releasePointerCapture(e.pointerId); } catch (_) {}
      syncProps();
      updateReadout();
    }

    el.addEventListener('pointermove', onMove);
    handle.addEventListener('pointermove', onMove);
    el.addEventListener('pointerup', onUp);
    handle.addEventListener('pointerup', onUp);
    el.addEventListener('pointercancel', onUp);
    handle.addEventListener('pointercancel', onUp);
  }

  // --- Per-side surcharge calc ---
  function computePrintInches(side) {
    const s = sides[side];
    if (!s.src) return { w_in: 0, h_in: 0, sq_in: 0 };
    const cw = canvas.clientWidth;
    const ch = canvas.clientHeight;
    const z = zoneFor(side);
    const zIn = zoneInchesFor(side);
    const fracW = ((s.w / cw) * 100) / z.width;
    const fracH = ((s.h / ch) * 100) / z.height;
    const w_in = fracW * zIn.width_in;
    const h_in = fracH * zIn.height_in;
    return { w_in, h_in, sq_in: w_in * h_in };
  }

  function computeSurchargeDollars(side) {
    const { sq_in } = computePrintInches(side);
    if (!sq_in) return 0;
    const raw = sq_in * config.rate_per_sq_in;
    return Math.max(minSurchargeFor(side), Math.round(raw * 100) / 100);
  }

  function totalSurchargeDollars() {
    return computeSurchargeDollars('front') + computeSurchargeDollars('back');
  }

  function getBasePriceCents() {
    const opts = getSelectedOptions();
    const v = findVariant(opts);
    return v ? v.price : (product?.price || 0);
  }

  function updateReadout() {
    const front = computePrintInches('front');
    const back  = computePrintInches('back');
    const fFee = computeSurchargeDollars('front');
    const bFee = computeSurchargeDollars('back');

    if (readoutSizeFront) readoutSizeFront.textContent = front.w_in ? `${front.w_in.toFixed(1)} × ${front.h_in.toFixed(1)} in` : '—';
    if (readoutSizeBack)  readoutSizeBack.textContent  = back.w_in  ? `${back.w_in.toFixed(1)} × ${back.h_in.toFixed(1)} in`   : '—';
    if (readoutFeeFront)  readoutFeeFront.textContent  = front.w_in ? '$' + fFee.toFixed(2) : '$0.00';
    if (readoutFeeBack)   readoutFeeBack.textContent   = back.w_in  ? '$' + bFee.toFixed(2) : '$0.00';

    if (totalEl) {
      const baseCents = getBasePriceCents();
      const totalCents = baseCents + Math.round(totalSurchargeDollars() * 100);
      totalEl.textContent = formatMoney(totalCents);
    }
  }

  function syncProps() {
    const cw = canvas.clientWidth;
    const ch = canvas.clientHeight;

    // Front
    if (sides.front.src) {
      const f = computePrintInches('front');
      const pos = {
        x_pct: +(sides.front.x / cw * 100).toFixed(2),
        y_pct: +(sides.front.y / ch * 100).toFixed(2),
        w_pct: +(sides.front.w / cw * 100).toFixed(2),
        h_pct: +(sides.front.h / ch * 100).toFixed(2),
        w_in:  +f.w_in.toFixed(2),
        h_in:  +f.h_in.toFixed(2),
      };
      propFrontImage.value = sides.front.file ? ('FILE:' + sides.front.file.name) : (sides.front.src.length > 1000 ? '[uploaded image]' : sides.front.src);
      propFrontPos.value = JSON.stringify(pos);
    } else {
      propFrontImage.value = '';
      propFrontPos.value = '';
    }

    // Back
    if (sides.back.src) {
      const b = computePrintInches('back');
      const pos = {
        x_pct: +(sides.back.x / cw * 100).toFixed(2),
        y_pct: +(sides.back.y / ch * 100).toFixed(2),
        w_pct: +(sides.back.w / cw * 100).toFixed(2),
        h_pct: +(sides.back.h / ch * 100).toFixed(2),
        w_in:  +b.w_in.toFixed(2),
        h_in:  +b.h_in.toFixed(2),
      };
      propBackImage.value = sides.back.file ? ('FILE:' + sides.back.file.name) : (sides.back.src.length > 1000 ? '[uploaded image]' : sides.back.src);
      propBackPos.value = JSON.stringify(pos);
    } else {
      propBackImage.value = '';
      propBackPos.value = '';
    }

    // Summary
    const parts = [];
    if (sides.front.src) {
      const f = computePrintInches('front');
      parts.push(`Front ${f.w_in.toFixed(1)}″×${f.h_in.toFixed(1)}″`);
    }
    if (sides.back.src) {
      const b = computePrintInches('back');
      parts.push(`Back ${b.w_in.toFixed(1)}″×${b.h_in.toFixed(1)}″`);
    }
    propSummary.value = parts.length ? parts.join(' · ') : 'No design uploaded';
  }

  // --- Variant selection ---
  function getSelectedOptions() {
    const result = {};
    form.querySelectorAll('input[type="radio"]:checked').forEach((i) => {
      const m = i.name.match(/^options\[(.+)\]$/);
      if (m) result[m[1]] = i.value;
    });
    return result;
  }

  function findVariant(opts) {
    if (!product) return null;
    const optionNames = product.options.map((o) => typeof o === 'string' ? o : o.name);
    return product.variants.find((v) => {
      return optionNames.every((name, i) => v[`option${i + 1}`] === opts[name]);
    });
  }

  function updateVariant() {
    const opts = getSelectedOptions();
    const v = findVariant(opts);
    if (!v) return;
    variantInput.value = v.id;
    priceEls.forEach((el) => el.textContent = formatMoney(v.price));

    // Update both sides' cached mockup based on selected color
    const color = getCurrentColor();
    const newFront = mockupFor('front', color);
    const newBack  = mockupFor('back',  color);
    sides.front.mockupSrc = newFront;
    sides.back.mockupSrc  = newBack;

    // Swap the visible canvas image to match the active side, with a quick fade
    const target = currentSide === 'front' ? newFront : newBack;
    if (mockupImg.src !== target) {
      canvas.classList.add('is-swapping');
      setTimeout(() => {
        mockupImg.src = target;
        canvas.classList.remove('is-swapping');
      }, 120);
    }

    updateReadout();
  }

  form.querySelectorAll('input[type="radio"]').forEach((i) => {
    i.addEventListener('change', updateVariant);
  });

  // --- Form submit: apparel + (optional) surcharge line ---
  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const submitBtn = form.querySelector('[data-kustm-add]');
    const origLabel = submitBtn ? submitBtn.innerHTML : '';
    if (submitBtn) { submitBtn.disabled = true; submitBtn.innerHTML = 'Adding…'; }

    try {
      const opts = getSelectedOptions();
      const v = findVariant(opts);
      if (!v) throw new Error('No variant selected');

      const surchargeDollars = totalSurchargeDollars();
      const f = computePrintInches('front');
      const b = computePrintInches('back');

      // Native Shopify file upload via standard (non-AJAX) form submit.
      // This is the ONLY path that actually persists file binary to the order admin.
      // We build a hidden form with file inputs and submit it — the page reloads to /cart.
      const hiddenForm = document.createElement('form');
      hiddenForm.method = 'post';
      hiddenForm.action = '/cart/add';
      hiddenForm.enctype = 'multipart/form-data';
      hiddenForm.style.display = 'none';

      function addField(name, value) {
        const i = document.createElement('input');
        i.type = 'hidden'; i.name = name; i.value = value;
        hiddenForm.appendChild(i);
      }
      function addFile(name, file) {
        const i = document.createElement('input');
        i.type = 'file'; i.name = name;
        const dt = new DataTransfer();
        dt.items.add(file);
        i.files = dt.files;
        hiddenForm.appendChild(i);
      }

      addField('id', String(v.id));
      addField('quantity', '1');
      if (sides.front.src) {
        if (sides.front.file) addFile('properties[Front Design File]', sides.front.file);
        addField('properties[Front Design]', `${f.w_in.toFixed(1)}″ × ${f.h_in.toFixed(1)}″`);
        addField('properties[_design_front_position]', propFrontPos.value);
      }
      if (sides.back.src) {
        if (sides.back.file) addFile('properties[Back Design File]', sides.back.file);
        addField('properties[Back Design]', `${b.w_in.toFixed(1)}″ × ${b.h_in.toFixed(1)}″`);
        addField('properties[_design_back_position]', propBackPos.value);
      }

      // If there's a surcharge, add hidden item via separate AJAX call BEFORE the form submit
      if (surchargeDollars > 0) {
        const feeParts = [];
        if (sides.front.src) feeParts.push(`Front ${f.w_in.toFixed(1)}×${f.h_in.toFixed(1)} in`);
        if (sides.back.src)  feeParts.push(`Back ${b.w_in.toFixed(1)}×${b.h_in.toFixed(1)} in`);
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{
            id: parseInt(config.surcharge_variant_id, 10),
            quantity: Math.ceil(surchargeDollars),
            properties: { '_for_design': '1', 'Print fee': feeParts.join(' · ') },
          }]}),
        }).catch(()=>{});
      }

      document.body.appendChild(hiddenForm);
      hiddenForm.submit();
      // Stop here — page is navigating
      return;

      // (unreachable below, kept for ESLint sanity)
      const res = { ok: true };
      if (!res.ok) throw new Error('Could not add to cart');
    } catch (err) {
      console.error('[KUSTM] Add to cart failed', err);
      alert('Could not add to cart: ' + (err.message || err));
      if (submitBtn) { submitBtn.disabled = false; submitBtn.innerHTML = origLabel; }
    }
  });

  // Initial sync
  syncProps();
  updateReadout();
})();
